import React from 'react';
import { IContext } from 'context/reducers';
import LoaderAnimation from './sub-components/loader-animation/LoaderAnimation';

type Props = {
  context: IContext;
};

const GlobalLoader: React.FC<Props> = props => {
  const { context } = props;
  const {
    loadingGlobal: { isLoading },
  } = context;
  return isLoading && <LoaderAnimation />;
};

export default GlobalLoader;
